import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useChatContext } from '../context/ChatContext';
import { logoutChat } from '../reducers/chat.reducer';

/**
 * Hook personalizado que sincroniza el estado de autenticación con el chat
 * Limpia automáticamente los mensajes del chat cuando el usuario cierra sesión
 */
export const useAuthChat = () => {
  const authState = useSelector(state => state.login);
  const { dispatch } = useChatContext();
  
  // Monitorear cambios en el estado de autenticación
  useEffect(() => {
    // Si el usuario no está logueado, limpiar mensajes del chat
    if (!authState?.logged) {
      dispatch(logoutChat());
      // También limpiar el localStorage para que no mantenga el ID de sesión
      localStorage.removeItem('chat_session_id');
    }
  }, [authState?.logged, dispatch]);

  return {
    isAuthenticated: authState?.logged,
    user: authState
  };
};
